import React from "react";
import {connect} from "react-redux";
import {Breadcrumb, Table, ButtonToolbar, Button, SplitButton, MenuItem, Glyphicon, FormControl, Row, Col} from "react-bootstrap";
import PaginationBar from "../../PaginationBar";
import {ButtonToggle} from "components/ButtonToggle";
import Loading from "components/Loading";
import {LinkContainer} from "react-router-bootstrap";
import HelpHintButton from "components/HelpHintButton";
import Request from "request";
import TicketCreateNumber from "./TicketCreateNumber";
import TicketCreateText from "./TicketCreateText";
import TicketCreateFile from "./TicketCreateFile";
import TicketCreated from "./TicketCreated";
import TicketDetails from "./TicketDetails";
import "./style";

class EventTickets extends React.Component {
	state = {
		isLoading: true,
		tickets: [],
		createdTickets: [],
		filterUsed: '',
		filterEnabled: '',
		filterEmail: '',
		filterTicketKey: '',
		isShowCreate: false,
		selectedTicket: null,
		activePage: 1,
		sendEmailToAllProgress: false,
	};

	constructor(props, context) {
		super(props, context);

		this.handleDelete = this.handleDelete.bind(this);
		this.handleEnabled = this.handleEnabled.bind(this);

		this.onCreatedTickets = this.onCreatedTickets.bind(this);

		this.showCreate = this.showCreate.bind(this);
		this.hideCreate = this.hideCreate.bind(this);

		this.hideCreated = this.hideCreated.bind(this);

		this.showTicketDetails = this.showTicketDetails.bind(this);
		this.hideTicketDetails = this.hideTicketDetails.bind(this);
	}

	componentDidMount() {
		this.fetchTickets();
	}

	fetchTickets() {
		const {event} = this.props;

		this.setState({isLoading: true, tickets: []});

		Request.get(`/api/cp/event/${event.eventPassword}/ticket`)
			.then(tickets => this.setState({tickets, activePage: 1}))
			.catch(() => {})
			.then(() => this.setState({isLoading: false}))
		;
	}

	handleSendMail(ticket) {
		const {event} = this.props;
		Request.post(`/api/cp/event/${event.eventPassword}/ticket/${ticket.ticket}/sendMail`)
			.then(ticket => {
				alert('Письмо отправлено');
				let tickets = this.state.tickets.slice();
				let index = tickets.findIndex(t => t.id === ticket.id);
				if(index >= 0) {
					tickets[index] = Object.assign({}, tickets[index], {email: ticket.email, sendMailTime: ticket.sendMailTime});
					this.setState({tickets});
				}
			})
			.catch(() => alert('Произошла ошибка при отправки письма'))
		;
	}
	handleEnabled(ticket, enabled) {
		const {event} = this.props;
		Request.put(`/api/cp/event/${event.eventPassword}/ticket/${ticket.ticket}`, {enabled: enabled})
			.then(ticket => {
				let tickets = this.state.tickets.slice();
				let index = tickets.findIndex(t => t.id === ticket.id);
				if(index >= 0) {
					tickets[index] = Object.assign({}, tickets[index], {enabled: ticket.enabled});
					this.setState({tickets});
				}
			})
	}
	handleDelete(ticket) {
		const {event} = this.props;

		if(!confirm(`Вы действительно хотите удалить билет "${ticket.ticket}"`)) return;
		Request.delete(`/api/cp/event/${event.eventPassword}/ticket/${ticket.ticket}`)
			.then(() => {
				let tickets = this.state.tickets.slice();
				let index = tickets.findIndex(t => t.id === ticket.id);
				if(index >= 0) {
					tickets.splice(index, 1);
					this.setState({tickets});
				}
			});
	}

	onCreatedTickets(tickets) {
		this.setState({isShowCreate: false, createdTickets: tickets, tickets: this.state.tickets.concat(tickets)});
	}

	showCreate(type) {
		this.setState({isShowCreate: type, createdTickets: []});
	}
	hideCreate() {
		this.setState({isShowCreate: false});
	}

	hideCreated() {
		this.setState({createdTickets: []});
	}

	showTicketDetails(ticket) {
		this.setState({selectedTicket: ticket});
	}
	hideTicketDetails() {
		this.setState({selectedTicket: null});
	}

	sendTicketEmailToAll()
	{
		const {event} = this.props;

		this.setState({sendEmailToAllProgress: true});

		fetch(`/api/cp/event/${event.eventPassword}/ticket/sendMail`, {method: 'POST'})
			.then((response) => {
				this.setState({sendEmailToAllProgress: false});

				if (response.ok) {
					alert('Письма отправлены');
				} else {
					alert('Произошла ошибка при отправки письем')
				}
			})
		;
	}

	render() {
		const ticketOnPage = 100;
		const {isLoading, tickets, filterUsed, filterEnabled, filterEmail, filterTicketKey, activePage} = this.state;
		const {event} = this.props;

		if(isLoading) return <Loading>Загрузка билетов</Loading>;

		let ticketFiltered = tickets;
		if(filterUsed) {
			switch(filterUsed) {
				case 'true': ticketFiltered = ticketFiltered.filter(ticket => !!ticket.verify); break;
				case 'false': ticketFiltered = ticketFiltered.filter(ticket => !ticket.verify); break;
			}
		}
		if(filterEnabled) {
			switch(filterEnabled) {
				case 'true': ticketFiltered = ticketFiltered.filter(ticket => !!ticket.enabled); break;
				case 'false': ticketFiltered = ticketFiltered.filter(ticket => !ticket.enabled); break;
			}
		}
		if(filterEmail) {
			ticketFiltered = ticketFiltered.filter(ticket => ~(ticket.email || '').indexOf(filterEmail));
		}
		if(filterTicketKey) {
			ticketFiltered = ticketFiltered.filter(ticket => ~(ticket.ticket || '').indexOf(filterTicketKey));
		}

		const pageCount = Math.ceil(ticketFiltered.length / ticketOnPage);

		ticketFiltered = ticketFiltered.slice((activePage - 1) * ticketOnPage, activePage * ticketOnPage);

		const TicketRow = ({ticket}) => {
			const PaymentStatus = ({status}) => {
				switch (status.toUpperCase()) {
					case 'DONE': return <span style={{color: 'green'}}>Оплачен</span>;
					case 'FAIL': return <span style={{color: 'red'}}>Ошибка</span>;
					default: return <span>Ожидает</span>
				}
			};

			return (
				<tr>
					<td>{ticket.email}</td>
					<td style={{fontFamily: 'Courier New, Courier, monospace'}}>https://{location.host}/watch/{ticket.ticket}</td>
					<td />
					{event.price > 0 ? <td>{ticket.paymentOrder ? `${ticket.paymentOrder.price} руб` : null}</td> : null}
					{event.price > 0 ? <td>{ticket.paymentOrder ? <PaymentStatus status={ticket.paymentOrder.status} /> : null}</td> : null}
					<td>{ticket.verify ? 'Да' : 'Нет'}</td>
					<td><ButtonToggle active={ticket.enabled} onClick={() => this.handleEnabled(ticket, !ticket.enabled)} /></td>
					<td style={{textAlign: 'right'}}>
						<Button bsSize="small" title="Отправить письмо с сылкой зрителю" onClick={() => this.handleSendMail(ticket)}><Glyphicon glyph="envelope" /></Button>
						<Button bsSize="small" title="Просмотреть информацию" onClick={() => this.showTicketDetails(ticket)}><Glyphicon glyph="info-sign"/></Button>
						<Button bsSize="small" title="Удалить билет" onClick={() => this.handleDelete(ticket)}><Glyphicon glyph="remove"/></Button>
					</td>
				</tr>
			);
		};

		return (
			<section className="Tickets">
				<Breadcrumb>
					<LinkContainer to={`/event/${event.eventPassword}`}><Breadcrumb.Item>Трансляция</Breadcrumb.Item></LinkContainer>
					<Breadcrumb.Item active>Билеты</Breadcrumb.Item>
				</Breadcrumb>
				<Row>
					<Col xs={6}>
						<ButtonToolbar>
							{(event.moduleMain.ticketLimit - tickets.length) > 0 && <span>
								<SplitButton title="Добавить" id="createTicketButtons" onClick={() => this.showCreate('number')} onSelect={type => this.showCreate(type)}>
									<MenuItem eventKey={'email'}>С рассылкой</MenuItem>
									<MenuItem eventKey={'file'}>С рассылкой из файла</MenuItem>
								</SplitButton>
								<Button>
									<HelpHintButton placement='right'>
										<p>Для добавления N-количества билетов - нажмите &quot;Добавить&quot;</p>
										<p>Для добавления билетов с рассылкой по eMail - нажмите &quot;Добавить с рассылкой&quot;</p>
										<p>Для добавления билетов с рассылкой по eMail из Excel - нажмите &quot;Добавить с рассылкой из файла&quot;</p>
									</HelpHintButton>
								</Button>
							</span>}
						</ButtonToolbar>
					</Col>
					<Col xs={6} style={{textAlign: 'right'}}>
						<Button href={`/api/cp/event/${event.eventPassword}/ticket.xlsx`}>Скачать</Button>
						<Button onClick={this.sendTicketEmailToAll.bind(this)} disabled={this.state.sendEmailToAllProgress}>Отправить письма всем</Button>
					</Col>
				</Row>

				<Table responsive>
					<thead>
					<tr>
						<th width="240">eMail</th>
						<th width="560">Ключ</th>
						<th />
						{event.price > 0 ? <th width="100">Стоимость</th> : null}
						{event.price > 0 ? <th width="100">Оплата</th> : null}
						<th width="80">Вход</th>
						<th width="80">Включен</th>
						<th width="120">{' '}</th>
					</tr>
					<tr>
						<td><FormControl type="text" onChange={event => this.setState({filterEmail: event.target.value})} /></td>
						<td><FormControl type="text" onChange={event => this.setState({filterTicketKey: event.target.value})} /></td>
						<td />
						{event.price > 0 ? <td /> : null}
						{event.price > 0 ? <td /> : null}
						<td>
							<FormControl componentClass="select" onChange={event => this.setState({filterUsed: event.target.value})}>
								<option value="">Все</option>
								<option value="true">Да</option>
								<option value="false">Нет</option>
							</FormControl>
						</td>
						<td>
							<FormControl componentClass="select" onChange={event => this.setState({filterEnabled: event.target.value})}>
								<option value="">Все</option>
								<option value="true">Да</option>
								<option value="false">Нет</option>
							</FormControl>
						</td>
					</tr>
					</thead>
					<tbody>
					{ticketFiltered.map((ticket) => <TicketRow ticket={ticket} key={ticket.ticket} />)}
					</tbody>
				</Table>

				<PaginationBar
					pageCount={pageCount}
					activePage={activePage}
					onSelect={(activePage) => this.setState({activePage})}
				/>

				{this.state.selectedTicket && <TicketDetails event={event} ticket={this.state.selectedTicket} onHide={this.hideTicketDetails} />}

				<TicketCreateNumber event={event} show={this.state.isShowCreate === 'number'}
					max={event.moduleMain.ticketLimit - tickets.length}
					onCreate={this.onCreatedTickets}
					onHide={this.hideCreate}
				/>

				<TicketCreateText event={event} show={this.state.isShowCreate === 'email'}
					max={event.moduleMain.ticketLimit - tickets.length}
					onCreate={this.onCreatedTickets}
					onHide={this.hideCreate}
				/>

				<TicketCreateFile event={event} show={this.state.isShowCreate === 'file'}
					max={event.moduleMain.ticketLimit - tickets.length}
					onCreate={this.onCreatedTickets}
					onHide={this.hideCreate}
				/>

				<TicketCreated tickets={this.state.createdTickets} show={this.state.createdTickets.length > 0} onHide={this.hideCreated} />
			</section>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(EventTickets);
